const getters = {
  languageList: (state) => state.languageList, //语言列表
  countryList: (state) => state.countryList, //国家列表
  deviceList: (state) => state.deviceList, //机型列表
  assemblyStyleList: (state) => state.assemblyStyleList, //组件样式列表
};
export default getters;
